import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  toFormatPrice,
  numberFormatter,
} from "../../Helper/PriceHelper";
import {
  StoneSizeList,
  StonesettingType,
  StoneUnitselect,
  GetPointer,
  GetShapeToStoneSize,
} from "./masters";

const handleKeyPress = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
  }
};

/**
 * Right-sidebar stone details for one row. Memoized with the left stone row.
 */
const ProductAdvancedStoneSidebar = ({
  element,
  index,
  topOffset,
  productVariantsEnable,
  shapeId,
  setFormValues_stone,
  onFieldChange,
  setValue,
  register,
}) => {
  const { t } = useTranslation();
  const hasStoneData = Object.keys(element || {}).length !== 0;

  if (hasStoneData) {
    return (
      <div
        className="product-sidebar-box box-bg box-input-40 position-absolute"
        style={{ top: topOffset }}
      >
        <table>
          <thead></thead>
          <tbody>
            <>
              {element?.StoneVariant === "2" &&
              productVariantsEnable === "2" ? (
                <tr>
                  <td>
                    <label>{t("Pointer")}</label>
                  </td>
                  <td>
                    <GetPointer
                      index_stone={index}
                      setFormValues_stone={setFormValues_stone}
                      selected_id={
                        element?.stonePointer ? element?.stonePointer : ""
                      }
                      shapeId={shapeId}
                      StoneShape={element?.StoneShape}
                    />
                  </td>
                </tr>
              ) : (
                ""
              )}
              <tr>
                <td>
                  <label>{t("Size")}</label>
                </td>
                <td>
                  <StoneSizeList
                    index_stone={index}
                    setFormValues_stone={setFormValues_stone}
                    selected_id={
                      element?.stoneSize ? element?.stoneSize : "value"
                    }
                    StoneShape={element?.StoneShape}
                    formShape_ids={shapeId ? { [index]: shapeId } : {}}
                  />
                  <div className="d-none">{element?.stoneSize}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{t("Pcs")}</label>
                </td>
                <td>
                  <div className="placeholder-up-input w-100">
                    <input
                      id={`stonePcs_${index}`}
                      onBlur={(e) =>
                        onFieldChange(e.target.value, index, "Pcs")
                      }
                      defaultValue={element.Pcs}
                      className="box-input handleAmount"
                      onKeyPress={handleKeyPress}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{t("Weight")} </label>
                </td>
                <td className="d-flex flex-nowrap">
                  <div
                    className="placeholder-up-input w-50"
                    style={{ padding: "1px" }}
                  >
                    <input
                      id={`stoneWeight_${index}`}
                      onBlur={(e) => {
                        const formatted = numberFormatter(
                          e.target.value ? e.target.value : 0
                        );
                        e.target.value = formatted;
                        setValue("Weight." + index, formatted);
                        onFieldChange(formatted, index, "Weight");
                      }}
                      defaultValue={numberFormatter(
                        element?.Weight ? element?.Weight : 0
                      )}
                      className="box-input"
                      onKeyPress={handleKeyPress}
                    />
                  </div>
                  <div
                    className="placeholder-up-input w-50"
                    style={{ padding: "1px" }}
                  >
                    <StoneUnitselect
                      index_stone={index}
                      setFormValues_stone={setFormValues_stone}
                      selected_id={
                        element?.WeightType ? element?.WeightType : "G"
                      }
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{t("Price")}</label>
                </td>
                <td>
                  <div className="placeholder-up-input w-100">
                    <input
                      id={`stonePrice_${index}`}
                      onBlur={(e) => {
                        setValue(
                          "stonePrice." + index,
                          toFormatPrice(e.target.value ? e.target.value : 0)
                        );
                        onFieldChange(e.target.value, index, "stonePrice");
                      }}
                      defaultValue={toFormatPrice(element.stonePrice)}
                      className="box-input"
                      onKeyPress={handleKeyPress}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{t("Setting")}</label>
                </td>
                <td>
                  <StonesettingType
                    index_stone={index}
                    setFormValues_stone={setFormValues_stone}
                    selected_id={
                      element?.setting_type ? element?.setting_type : "value"
                    }
                  />
                </td>
              </tr>
            </>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div
      className="product-sidebar-box box-bg box-input-40 position-absolute"
      style={{ top: topOffset }}
    >
      <table>
        <thead></thead>
        <tbody>
          {element?.StoneVariant === 2 && productVariantsEnable === 2 ? (
            <tr>
              <td>
                <label>{t("Pointer")}</label>
              </td>
              <td>
                <GetPointer
                  index_stone={index}
                  setFormValues_stone={setFormValues_stone}
                  selected_id={
                    element?.stonePointer ? element?.stonePointer : ""
                  }
                  shapeId={shapeId}
                  StoneShape={element?.StoneShape}
                />
              </td>
            </tr>
          ) : (
            ""
          )}
          <tr>
            <td>
              <label>{t("Size")}</label>
            </td>
            <td>
              <GetShapeToStoneSize
                index_stone={index}
                setFormValues_stone={setFormValues_stone}
                selected_id={element?.stoneSize ? element?.stoneSize : ""}
                send_StoneVarint={element?.StoneVariant}
                StoneShape_id={element?.StoneShape}
              />
            </td>
          </tr>
          <tr>
            <td>
              <label>{t("Pcs")}</label>
            </td>
            <td>
              <div className="placeholder-up-input w-100">
                <input
                  {...register("Pcs." + index)}
                  className="box-input handleAmount"
                  onKeyPress={handleKeyPress}
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>{t("Weight")} </label>
            </td>
            <td>
              <div className="placeholder-up-input w-100">
                <input
                  {...register("Weight." + index, {
                    onBlur: (e) => {
                      setValue(
                        "Weight." + index,
                        numberFormatter(e.target.value ? e.target.value : 0)
                      );
                    },
                  })}
                  className="box-input"
                  onKeyPress={handleKeyPress}
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>{t("Price")}</label>
            </td>
            <td>
              <div className="placeholder-up-input w-100">
                <input
                  {...register("stonePrice." + index, {
                    onBlur: (e) => {
                      setValue(
                        "stonePrice." + index,
                        toFormatPrice(e.target.value ? e.target.value : 0)
                      );
                    },
                  })}
                  className="box-input"
                  onKeyPress={handleKeyPress}
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>{t("Setting")}</label>
            </td>
            <td>
              <StonesettingType
                index_stone={index}
                setFormValues_stone={setFormValues_stone}
                selected_id={
                  element?.setting_type ? element?.setting_type : "value"
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default memo(ProductAdvancedStoneSidebar);
